export const getSorter = <T>(dataIndex: string) => {
  const sorter = (a: T, b: T): number => {
    const [valueA, valueB] = [a[dataIndex], b[dataIndex]];
    if (valueA?.toString && valueB?.toString) {
      return valueA.toString().localeCompare(valueB.toString());
    }
    return 0;
  };
  return sorter;
};
